<template>
  <div :class="distinguish == 2 ? 'disaster' : 'disaster1'">
    <div class="backimg"></div>
    <!-- 1 -->
    <div  :class="distinguish == 2 ? 'disaster-now' : 'disaster-nowr'">
      <div class="disaster-top">
        <img :src="disasterber == 0 ? list[0] : list1[0]" alt />
      </div>
      <span
        class="name"
        :style="{
          backgroundImage: disasterber == 0 ? `url(${imga})` : `url(${imga1})`,
        }"
        @click="disaster(0)"
      >触控喷雾</span>
    </div>
    <!-- 2 -->
    <div  :class="distinguish == 2 ? 'disaster-now2' : 'disaster-now2r'">
      <div class="disaster-top">
        <img :src="disasterber == 1 ? list[1] : list1[1]" :class="disasterber == 1 ? 'a' : ''" alt />
      </div>
      <span
        class="name"
        :style="{
          backgroundImage: disasterber == 1 ? `url(${imga})` : `url(${imga1})`,
        }"
        @click="disaster(1)"
      >超限喷雾</span>
    </div>
    <!-- 3 -->
    <div :class="distinguish == 2 ? 'disaster-now3' : 'disaster-now3r'">
      <div class="disaster-top">
        <img :src="disasterber == 2 ? list[2] : list1[2]" :class="disasterber == 2 ? 'a' : ''" alt />
      </div>
      <span
        class="name"
        :style="{
          backgroundImage: disasterber == 2 ? `url(${imga})` : `url(${imga1})`,
        }"
        @click="disaster(2)"
      >自动喷雾</span>
    </div>
    <!-- 4 -->
    <div :class="distinguish == 2 ? 'disaster-now4' : 'disaster-now4r'">
      <div class="disaster-top">
        <img :src="disasterber == 3 ? list[3] : list1[3]" :class="disasterber == 3 ? 'a' : ''" alt />
      </div>
      <span
        class="name"
        :style="{
          backgroundImage: disasterber == 3 ? `url(${imga})` : `url(${imga1})`,
        }"
        @click="disaster(3)"
      >火灾</span>
    </div>
    <!-- 5 -->
    <div v-show='show' :class="distinguish == 2 ? 'disaster-now5' : 'disaster-now5r'">
      <div class="disaster-top">
        <img :src="disasterber == 4 ? list[4] : list1[4]" alt />
      </div>
      <span
        class="name"
        :style="{
          backgroundImage: disasterber == 4 ? `url(${imga})` : `url(${imga1})`,
        }"
        @click="disaster(4)"
      >避灾路线</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["distinguish"],
  data() {
    return {
      disasterber: -1,
      list: [
        require("../../../assets/zh/ws0.png"),
        require("../../../assets/zh/fc1.png"),
        require("../../../assets/zh/sz2.png"),
        require("../../../assets/zh/hz3.png"),
        require("../../../assets/zh/bzlx4.png")
      ],
      list1: [
        require("../../../assets/zh/ws.png"),
        require("../../../assets/zh/fc.png"),
        require("../../../assets/zh/sz.png"),
        require("../../../assets/zh/hz.png"),
        require("../../../assets/zh/bzlx.png")
      ],
      imga: require("../../../assets/sb/back.png"),
      imga1: require("../../../assets/sb/back1.png"),
      show: false,
    };
  },
  mounted() {
    // 父组件 传入的参数
    if (this.distinguish == 1) {
      this.disasterber = -1;
    }
  },
  methods: {
    disaster(i) {
      if (this.disasterber == i) {
        // 三维 模拟灾害  取消
        // document.getElementById("iframe").contentWindow.MMAPI.risk(9);
        this.disasterber = 100;
        return;
      }
      // 三维 模拟灾害
      // document.getElementById("iframe").contentWindow.MMAPI.risk(i);
      this.disasterber = i;
      this.emit.$emit("item4", i);
    }
  }
};
</script>
<style lang="less" scoped>
.disaster {
  width: 15vw;
  position: absolute;
  height: 75%;
  margin-left: 2vw;
  transition: all 1s;
  transform: translateY(0%);
}
.disaster1 {
  position: absolute;
  width: 15vw;
  height: 75%;
  margin-left: 2vw;
  transition: all 1s;
  transform: translateY(110%);
}
.backimg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/arc.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
}

// 第一个动画
.disaster-now {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 13vh;
  margin-left: -1vw;
  .keyframes();
}
.disaster-nowr {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 14vh;
  margin-left: -1vw;
}
// 第二个动画
.disaster-now2 {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 24vh;
  margin-left: -2vw;
  .keyframes(@delay:1.2s);
}
.disaster-now2r {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 24vh;
  margin-left: -2vw;
}
// 第三个动画
.disaster-now3 {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 34vh;
  margin-left: -2.3vw;
  .keyframes(@delay:1.4s);
}
.disaster-now3r {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 34vh;
  margin-left: -2.3vw;
}
// 第四个动画
.disaster-now4 {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 46vh;
  margin-left: -1.8vw;
  .keyframes(@delay:1.6s);
}
.disaster-now4r {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 44vh;
  margin-left: -1.8vw;
}
// 第五个动画
.disaster-now5 {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 54vh;
  margin-left: -0.2vw;
  .keyframes(@delay:1.8s);
}
.disaster-now5r {
  width: 11vw;
  position: absolute;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 54vh;
  margin-left: -0.2vw;
  color: #colors[secondary];
}

.disaster-top {
  // width: 50%;
  // height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
.name {
  display: block;
  width: 5vw;
  padding: 0.2vh 0.5vw;
  margin-top: 2vh;
  font-size: 0.8vw;
  margin-left: 0.1vw;
  color: #e8e8e8;
  letter-spacing: 0.1vw;
  cursor: pointer;
  background-size: 80% 100%;
  background-repeat: no-repeat;
  white-space: nowrap;
}

</style>